<template>
  <div class="full-width text-end">
    <v-menu open-on-hover bottom offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-if="!loading" class="mt-6 mr-4 mb-0" color="green" dark v-bind="attrs" v-on="on" outlined>
          Nhập/xuất Excel
        </v-btn>
        <v-btn v-else class="mt-6 mr-4 mb-0" color="green" dark v-bind="attrs" v-on="on" outlined>
          <div :style="{ width: '145px', height: '36px' }" class="d-flex justify-center align-center">
            <v-progress-circular indeterminate size="22" color="green" :width="2" />
          </div>
        </v-btn>
      </template>

      <v-list>
        <v-list-item class="cursor-pointer" @click="() => $refs['import-dialog'].openPopup()">
          <v-list-item-title>Tải lên file Excel</v-list-item-title>
        </v-list-item>
        <v-list-item class="cursor-pointer" @click="() => $refs['excel-export-compo'].getData()">
          <v-list-item-title>
            <ExcelExport ref="excel-export-compo" :query="query" />
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <ImportDialog :filterParams="filterParam" ref="import-dialog" />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import ExcelExport from './ExcelExport.vue'
import ImportDialog from './import/index.vue'
export default {
  props: {
    query: Object,
    loading: Boolean
  },
  components: {
    ImportDialog,
    ExcelExport
  },
  computed: {
    ...mapState('ClassMarkInput', ['filterParam'])
  }
}
</script>
